import React from "react";
import PropTypes from "prop-types";

const ConfirmationDetails = ({
  message,
  imageSrc,
  onClose
}) => /*#__PURE__*/React.createElement("div", {
  className: "message"
}, /*#__PURE__*/React.createElement("h2", null, message), /*#__PURE__*/React.createElement("img", {
  src: imageSrc,
  alt: "Parcel box"
}), /*#__PURE__*/React.createElement("button", {
  onClick: onClose
}, "Close"), /*#__PURE__*/React.createElement("p", {
  className: "powered-by"
}, "Crash reports powered by ", /*#__PURE__*/React.createElement("a", {
  href: "https://sentry.io"
}, "Sentry")));

ConfirmationDetails.propTypes = {
  message: PropTypes.string,
  imageSrc: PropTypes.any,
  onClose: PropTypes.func
};
export default ConfirmationDetails;